export default __webpack_public_path__ + "static/media/runkeeper-track-before-2.d229d729.svg";